import store from '@/store/index';
import studentEvaluationService from '@/modules/student-evaluations/api.js';

export const TRIANNUAL_PARTICIPANT_SIGNATURES_EDIT_PERMISSION =
  'academic.student.triannualdetermination.participantsignatures.edit';

export function isTriannualReviewCompleted(triennialPlacementCommitteId) {
  return (
    triennialPlacementCommitteId !== null &&
    triennialPlacementCommitteId !== undefined
  );
}

export function canEditTriannualParticipantSignatures({
  evaluationDateId,
  isLoaded,
  isCompleted,
  hasPermission,
}) {
  return Boolean(evaluationDateId) && isLoaded && !isCompleted && hasPermission;
}

export function shouldShowTriannualParticipantSignatures({
  showSection,
  isNotEnoughtInformation,
}) {
  return Boolean(showSection || isNotEnoughtInformation);
}

export function resolveTriannualParticipantSignatureSources({
  elegibilityInfo,
  signatures,
}) {
  if (elegibilityInfo) {
    return {
      signatureListWithoutCometee: [],
      elegibilitySignatureList: elegibilityInfo.signatures || [],
    };
  }

  return {
    signatureListWithoutCometee: signatures || [],
    elegibilitySignatureList: null,
  };
}

export default {
  data: () => ({
    triennialPlacementCommitteId: null,
    evaluationDateInfoLoaded: false,
    participantSignaturesSaving: false,
  }),
  computed: {
    isTriannualCompleted() {
      return isTriannualReviewCompleted(
        this.triennialPlacementCommitteId
      );
    },
    hasParticipantSignaturesEditPermission() {
      return store.getters.HasPermission(
        TRIANNUAL_PARTICIPANT_SIGNATURES_EDIT_PERMISSION
      );
    },
    isExistingEvaluationDate() {
      return Boolean(this.evaluationDateId);
    },
    canEditIncompleteParticipantSignatures() {
      return canEditTriannualParticipantSignatures({
        evaluationDateId: this.evaluationDateId,
        isLoaded: this.evaluationDateInfoLoaded,
        isCompleted: this.isTriannualCompleted,
        hasPermission: this.hasParticipantSignaturesEditPermission,
      });
    },
    shouldShowParticipantSignatures() {
      return shouldShowTriannualParticipantSignatures({
        showSection: this.showSection,
        isNotEnoughtInformation: this.isNotEnoughtInformation,
      });
    },
    participantSignaturesReadOnly() {
      if (this.isExistingEvaluationDate) {
        return !this.canEditIncompleteParticipantSignatures;
      }

      return Boolean(this.submitted);
    },
    participantSignaturesIsDraft() {
      return !this.participantSignaturesReadOnly;
    },
    canShowSaveButton() {
      if (this.isExistingEvaluationDate) {
        return this.canEditIncompleteParticipantSignatures;
      }

      return this.canPost;
    },
  },
  methods: {
    async handleSaveAction() {
      if (this.isExistingEvaluationDate) {
        await this.saveTriannualParticipantSignatures();
        return;
      }

      await this.handleSubmit();
    },
    async saveTriannualParticipantSignatures() {
      const isValid = await this.$refs.signatureObserver.validate();
      if (!isValid) return;

      const signatures = this.getSignatureList().map((signature) => ({
        ...signature,
        positionId:
          signature.positionId === null || signature.positionId === undefined
            ? signature.positionId
            : String(signature.positionId),
      }));

      this.participantSignaturesSaving = true;

      try {
        await studentEvaluationService.updateTriannualParticipantSignatures(
          this.evaluationDateId,
          signatures
        );

        this.ShowToast(
          '',
          'Firma de Participantes actualizada exitosamente.',
          'success'
        );
        await this.getEvaluationDateInfo(this.evaluationDateId);
      } catch (error) {
        const message =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;

        this.ShowToast(
          'Alerta',
          message ||
            'Ha ocurrido un error mientras se procesaba la información.',
          'error'
        );
      } finally {
        this.participantSignaturesSaving = false;
      }
    },
  },
};
